import { GroupOrderSetupScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GroupOrderSetupScreen />;
}
